import React from 'react';
import { useLanguage } from '../LanguageContext';
import { motion } from 'framer-motion';
import { BookOpen, Zap, Calendar } from 'lucide-react';
export const Program = () => {
  const {
    t
  } = useLanguage();
  return <section id="program" className="py-24 bg-slate-900 text-white relative overflow-hidden" data-id="element-140">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#4f46e5 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-141"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-142">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-143">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-500/20 text-indigo-300 font-medium text-sm mb-6 border border-indigo-500/30" data-id="element-144">
            <Calendar size={16} data-id="element-145" />
            8-Week Structure
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-146">
            {t.program.title}
          </h2>
          <p className="text-xl text-slate-400" data-id="element-147">{t.program.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-148">
          {/* Track 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-3xl p-6 sm:p-8 hover:bg-slate-800 transition-colors" data-id="element-149">
            <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-6 text-blue-400 border border-blue-500/30" data-id="element-150">
              <BookOpen size={24} data-id="element-151" />
            </div>
            <div className="text-sm font-bold text-blue-400 tracking-wider uppercase mb-2" data-id="element-152">
              Track 1
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-153">
              {t.program.track1.title}
            </h3>
            <p className="text-slate-400 leading-relaxed mb-8" data-id="element-154">
              {t.program.track1.desc}
            </p>
            <ul className="space-y-3" data-id="element-155">
              {['Essential grammar foundations', 'Everyday vocabulary building', 'Basic conversational confidence'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-300" data-id="element-156">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-400" data-id="element-157"></div>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Track 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-3xl p-6 sm:p-8 hover:bg-slate-800 transition-colors relative overflow-hidden" data-id="element-158">
            <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/10 rounded-bl-full -mr-16 -mt-16" data-id="element-159"></div>
            <div className="w-12 h-12 bg-indigo-500/20 rounded-xl flex items-center justify-center mb-6 text-indigo-400 border border-indigo-500/30" data-id="element-160">
              <Zap size={24} data-id="element-161" />
            </div>
            <div className="text-sm font-bold text-indigo-400 tracking-wider uppercase mb-2" data-id="element-162">
              Track 2
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-163">
              {t.program.track2.title}
            </h3>
            <p className="text-slate-400 leading-relaxed mb-8" data-id="element-164">
              {t.program.track2.desc}
            </p>
            <ul className="space-y-3" data-id="element-165">
              {['Advanced pronunciation refinement', 'Mastery of complex tenses', 'Native-like fluid conversation'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-300" data-id="element-166">
                  <div className="w-1.5 h-1.5 rounded-full bg-indigo-400" data-id="element-167"></div>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};